import React, { useEffect, useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Button } from '@mybridge/ui/button';
// import { Dropdown } from '@mybridge/ui/dropdown';

import { LANG_CHOICES } from 'v4/components/data/data';

import { updateUserDetails } from 'packages/mybridgev4/store/actions/user-profile.actions';
import { Box, Flex, FormControl, Stack, Text, Spinner } from '@mybridge/ui';
import { LanguageDropdown } from 'v4/components/language-dropdown';
import { getGlobalLanguages } from 'v4/store/actions/global.data.actions';
import _ from 'lodash';
import { useLanguage } from 'v4/lib/hooks/use-language';
import { AddCircle, EditIcon, LanguageIcon } from '@mybridge/icons';
import styles from './settings.module.scss';
import { isMobile } from 'react-device-detect';
import { IconButton } from '@mybridge/ui/icon-button';
import { loadDictionary, setLanguage } from 'v4/store/slices/translationSlice';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDir } from 'packages/mybridgev4/context/direction-context';
import { ANALYTICS_EVENTS, trackEvent } from 'v4/utils/analyticsEvents';
import { useRouter } from 'next/router';

const Language = ({setIsEditing,setSelectedAccountComponent,setEditMode,editMode}) => {
  const dispatch = useDispatch();
  const { t } = useTranslator();
  const { setDirection } = useDir();
  const { userProfileInfo, updateStatus } = useSelector(
    (state) => state.userProfile
  );
  const { globalLanguages } = useSelector((state) => state.globalData);
  const [search, setSearch] = useState(userProfileInfo?.lang || 'en');
  const [language, setLangage] = useState('');
  const { data, refetch, createLoading, mutateAsync, isLoading } = useLanguage({
    search,
  });
  const currentLanguage = useSelector((state) => state.translation.language);

  // const languages = useMemo(
  //   () => data?.pages?.reduceRight?.((ac, p) => ac.concat(p?.results), []),
  //   [data?.pages]
  // );
  const languages = [
    { name: 'English', lang_code: 'en' },
    { name: 'French (Français)', lang_code: 'fr' },
    { name: 'German (Deutsch)', lang_code: 'de' },
    { name: 'Portuguese (Português)', lang_code: 'pt' },
    { name: 'Spanish (Español)', lang_code: 'es' },
    { name: 'Hindi (हिंदी)', lang_code: 'hi' },
    { name: 'Chinese (中文)', lang_code: 'zh-cn' },
    { name: 'Korean (한국어)', lang_code: 'ko' },
    { name: 'Japanese (日本語)', lang_code: 'ja' },
    { name: 'Russian (Русский)', lang_code: 'ru' },
    { name: 'Turkish (Türkçe)', lang_code: 'tr' },
    { name: 'Arabic (العربية)', lang_code: 'ar' },
    { name: 'Indonesian (Bahasa Indonesia)', lang_code: 'id' },
    { name: 'Vietnamese (Tiếng Việt)', lang_code: 'vi' },
    { name: 'Italian (Italiano)', lang_code: 'it' }
  ];

  const [values, setValues] = useState({});
  const [errors, setErrors] = useState({});
  const router = useRouter();

  useEffect(() => {
    if (userProfileInfo?.id) {
      setValues(userProfileInfo);
    }
    dispatch(getGlobalLanguages());
    return () => setValues({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fieldsOnChange = (e) => {
    const name = 'lang';
    const value = e.lang_code;
    // const { name, value } = e.target;
    setValues((prevValues) => ({ ...prevValues, [name]: value }));
    refetch?.();
  };

  const trackLanguageChange = () => {
    const userSlug = userProfileInfo?.slug;
    if (!userSlug) return;

    trackEvent(ANALYTICS_EVENTS.ChangeLanguage, userSlug, {
      selectedLanguage: values.lang,
      timestamp: new Date().toISOString()
    });
  };

  const onClickSave = () => {
    const errorObject = {};
    if (!values.lang) {
      errorObject.lang = t('settingAccount.pleaseSelectLanguage') || 'Please select langage';
    }

    if (Object.keys(errorObject).length > 0) {
      setErrors(errorObject);
      return;
    }
    dispatch(updateUserDetails({ lang: values.lang })).then(() => {
      localStorage.setItem('userLanguage', values.lang);
      dispatch(setLanguage(values.lang));
      dispatch(loadDictionary(values.lang));
      // Update direction based on language
      const isRTL = ['ar'].includes(values.lang);
      setDirection(isRTL ? 'rtl' : 'ltr');
      if (typeof document !== 'undefined') {
        document.documentElement.lang = values.lang;
        document.documentElement.setAttribute('lang', values.lang);
      }
      onClickCancel();
    }).then(()=>{
      trackLanguageChange();
    });
  };

  // console.log('globalLanguages', language);
  useEffect(() => {
    if (userProfileInfo?.lang && userProfileInfo?.lang !== 'en') {
      setLangage(
        _.find(globalLanguages, ['lang_code', userProfileInfo.lang || 'en'])?.name || 'English'
      );
    } else {
      // Default to English if no language is set
      setLangage('English');
    }
  }, [globalLanguages, userProfileInfo]);

  const onClickCancel = () => {
    setEditMode(false);
    setErrors({});
    setValues(userProfileInfo);
    setIsEditing('');
    setSelectedAccountComponent('account')
  };

  return (
    <Box py={['0px', '15px']}>
      <Flex justifyContent="space-between" p={['10px', '0']}>
        {/* <Box w={['100%', '350px']}> */}
        <Box flex={1} maxW="350px" mr={4} minW="0">
          {isMobile && !editMode && (
            <>
              {/* <Box mt={3} display="flex" alignItems="center"> */}
              <Box mt={3} display="flex" alignItems="center" minW="0">
                <LanguageIcon width="24"
                      height="24" style={{ marginRight: '10px' }} color="#868585" />
                <Text
                  color="#868585"
                  width="90%" // Set the width to 90%
                  whiteSpace="nowrap" // Prevent text from wrapping to the next line
                  overflow="hidden" // Hide overflow text
                  textOverflow="ellipsis"
                >
                  {/* {language ? language : 'English'} */}
                  {_.find(languages, ['lang_code', userProfileInfo?.lang])?.name || 'English'}
                </Text>
              </Box>
              <Text color="#868585" fontSize={['12px']} ml="35px">
                {t('profileDetails.languages') || 'Languages'}
              </Text>
            </>
          )}
          {!editMode && !isMobile && (
            <Box flex="1">
              {/* <Text color="brandGray.700">{t('settingAccount.language') || "Language"}</Text> */}
              <Text color="brandGray.700" fontSize={['16px', '14px', '14px', '16px']}>{t('settingAccount.language') || "Language"}</Text>
            </Box>
          )}
          {/* <Text fontSize="sm" color="brandGray.700" mt="10px">
            Select the language you use
          </Text> */}
          {editMode && (
            <Box
              className="row g-0 justify-content-md-between"
              p={['10px', '0']}
            >
              {isMobile && (
                <>
                  <Text color="brandGray.700" fontSize={['20px', '16px']}>
                    {t('settingAccount.language') || "Language"}
                  </Text>
                  <Text fontSize={['md', 'sm']} color="brandGray.700" mt="10px">
                    {t('settingAccount.selectLanguage') || "Select the language you use"}
                  </Text>
                </>
              )}
              <>
                {isMobile ? (
                  <>
                    <Flex flexDirection="column" gap={3} mt="5%">
                      <FormControl>
                        <LanguageDropdown
                          onChange={fieldsOnChange}
                          // value={language ? language : 'English'}
                          value={_.find(languages, ['lang_code', userProfileInfo?.lang])?.name || 'English'}
                          placeholder={t('settingAccount.chooseLanguage') || "Choose Language"}
                          name={'lang'}
                          className={styles.dataDisplayBoxes}
                          // defaultValue={language ? language : 'English'}
                          defaultValue={_.find(languages, ['lang_code', userProfileInfo?.lang])?.name || 'English'}
                          allowCreate={false}
                        />
                        {errors.lang && (
                          <div className="text-danger">{errors.lang}</div>
                        )}
                      </FormControl>
                    </Flex>
                    <Flex
                      justifyContent={isMobile ? 'flex-end' : 'space-between'}
                      columnGap="2"
                      mt={['5%', '2%']}
                    >
                      <Button
                        onClick={onClickCancel}
                        borderRadius={['30px', '30px']}
                        bg="#E4E6EB"
                      >
                        {t('buttons.cancel') || "Cancel"}
                      </Button>
                      <Button
                        disabled={updateStatus === 'pending' || !values?.lang}
                        onClick={onClickSave}
                        variant='primary'
                        borderRadius={['30px', '30px']}
                      >
                        {updateStatus === 'pending' ? <Spinner /> : t('buttons.save') || 'Save'}
                      </Button>
                    </Flex>
                  </>
                ) : (
                  <Stack spacing="2" my="10px">
                    {/* <Select
              name={'lang'}
              title={'language'}
              onChange={fieldsOnChange}
              value={values.lang}
            >
              {LANG_CHOICES.map((item, i) => (
                <option key={i} value={item.value}>
                  {item.label}
                </option>
              ))}
            </Select> */}
                    <FormControl>
                      <LanguageDropdown
                        onChange={fieldsOnChange}
                        // value={language ? language : 'English'}
                        value={_.find(languages, ['lang_code', userProfileInfo?.lang])?.name || 'English'}
                        placeholder={t('settingAccount.chooseLanguage') || "Choose Language"}
                        name={'lang'}
                        variant="greyRounded"
                        // defaultValue={language ? language : 'English'}
                        defaultValue={_.find(languages, ['lang_code', userProfileInfo?.lang])?.name || 'English'}
                        allowCreate={false}
                        isTranslationDropdown={true}
                      />
                      {errors.lang && (
                        <div className="text-danger">{errors.lang}</div>
                      )}
                    </FormControl>
                    <Flex gap="2">
                      <Button borderRadius="30px" onClick={onClickCancel}>{t('buttons.cancel') || "Cancel"}</Button>
                      <Button
                        borderRadius="30px"
                        // disabled={updateStatus === 'pending'}
                        disabled={updateStatus === 'pending' || !values?.lang}
                        onClick={onClickSave}
                        variant="primary"
                      >
                        {updateStatus === 'pending' ? <Spinner /> : t('buttons.save') || 'Save'}
                      </Button>
                    </Flex>
                  </Stack>
                )}
                {!isMobile && <Box mt={3}>
                  <hr />
                </Box>}
              </>
            </Box>
          )}
          {!isMobile && <Text className={styles.dataDisplayBoxes} mt={3}>
            {/* {language ? language : 'English'} */}
            {_.find(languages, ['lang_code', userProfileInfo?.lang])?.name || 'English'}
          </Text>}
        </Box>
        {isMobile && !editMode ? (
          <IconButton
            bg="none"
            onClick={() => {setEditMode(true);
              setIsEditing('language');
              setSelectedAccountComponent('language');}
            }
            icon={<EditIcon />}
          />
        ) : (
          !editMode && (
            <Button
              variant="ghost"
              borderRadius={"30px"}
              color="black"
              onClick={() => {
                setEditMode(true);
                setIsEditing('language');
                setSelectedAccountComponent('language');
              }}
              leftIcon={<AddCircle width={20} height={20} />}
              fontSize={['14px', '13px', '13px', '14px']}
            >
              {t('settingAccount.editLanguage') || "Edit Language"}
            </Button>
          )
        )}
      </Flex>
    </Box>
  );
};

export default Language;
